import { searchPointBulkGrantHistory } from "../api";
export default {
    name: "PointInfo",
    props: {
        // id が優先される挙動にするため optional にしておく
        point_bulk_grant_history_id: {
            type: String,
            required: false,
        },
        // item を直接渡す場合は完全な PointItem を期待
        item: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            itemState: null,
        };
    },
    mounted() {
        // 起動時に props をチェックして分岐
        // id が存在すれば id を優先して API を呼ぶ
        const id = this.point_bulk_grant_history_id;
        const passedItem = this.item;
        if (id) {
            this.getPointBulkGrantHistory(id);
        }
        else if (passedItem) {
            this.itemState = { ...passedItem };
        }
    },
    methods: {
        async getPointBulkGrantHistory(point_bulk_grant_history_id) {
            this.loading = true;
            try {
                const rspBody = await searchPointBulkGrantHistory(point_bulk_grant_history_id);
                if (rspBody.result?.code === 9) {
                    if (rspBody.result?.messages) {
                        this.$store.commit("setMessages", rspBody.result.messages);
                        this.$store.commit("setCancelBtnHide", true);
                        this.$store.commit("setIsModalOpen", true);
                    }
                }
                else if (Array.isArray(rspBody.data?.results) &&
                    rspBody.data.results.length > 1) {
                    this.$store.commit("setMessages", "取得件数が多いです。");
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    const result = rspBody.data?.results[0];
                    this.itemState = {
                        brand: result.brand,
                        store: result.store,
                        point_name: result.point_name,
                        point_grant_reason: result.point_grant_reason,
                        points: result.points,
                        effective_period_date: result.effective_period_date,
                        publisher: result.publisher,
                    };
                    this.$store.commit("setPointInfo", this.itemState);
                }
            }
            catch (err) {
                console.error("API error:", err);
            }
        },
    },
};
